import styled from '@emotion/styled';

import { UnstyledButton } from '@app/components/Button';
import { bigMobile } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

export const ModalWrapper = styled.div`
  background: ${({ theme }) => theme.colors.blueishGray};
  border-radius: ${rem(4)};
  width: 35rem;
  padding: ${rem(40)};
  position: relative;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${bigMobile}) {
    flex-grow: 2;
    margin-top: 0;
    width: 100%;
    border-radius: 0;
    padding: ${rem(24)};
  }
`;

export const CloseButton = styled(UnstyledButton)`
  min-width: ${rem(18)};
  cursor: pointer;
  position: absolute;
  right: ${rem(40)};
  top: ${rem(46)};
  @media screen and (max-width: ${bigMobile}) {
    top: ${rem(27)};
    right: ${rem(24)};
  }
`;
